var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-circle",class:[_vm.color ? 'label-circle--' + _vm.color : '']},[(_vm.value.length === 1)?[_c('span',[_vm._v(" "+_vm._s(_vm.value)+" ")])]:[_vm._v(" "+_vm._s(_vm.value)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }